// extracted by mini-css-extract-plugin
export default {"root":"IconSpinner_root__mpNC8"};